// @ts-ignore
import Swiper, { Pagination, Navigation} from 'swiper';
Swiper.use([Pagination, Navigation]);


export namespace ImageVideoCarousel {
	let setupImageVideoCarousel = () => {
		let sliderContainers = document.querySelectorAll('.js-image-video-carousel');

		if(!sliderContainers.length) {
			return;
		}

		sliderContainers.forEach((slider, index) => {
			let sliderList = [];
			let parentContainer = slider.closest('.image-video-carousel');
			let swiperPrevButton = parentContainer.querySelector('.swiper-button-prev');
			let swiperNextButton = parentContainer.querySelector('.swiper-button-next');
			slider.classList.add(`image-video-carousel--${index}`);
			swiperPrevButton.classList.add(`swiper-button-prev-${index}`);
			swiperNextButton.classList.add(`swiper-button-next-${index}`);

			//setup each swiper instance
			let swiper:any = new Swiper(`.image-video-carousel--${index}`,{
				slidesPerView: 3,
				navigation: {
					nextEl: `.swiper-button-next-${index}`,
					prevEl: `.swiper-button-prev-${index}`
				},
				breakpoints: {
					0: {
						slidesPerView: 1
					},
					768: {
						slidesPerView: 2
					},
					992: {
						slidesPerView: 3
					},
				}
			});

			//push up the swiper data
			sliderList.push(swiper);

			swiper.on('init', function(){

			});
			swiper.init();
		});
	}

	export const init = () => {
		setupImageVideoCarousel();
	}
}
